import { render, staticRenderFns } from "./ReleasesTable.vue?vue&type=template&id=739e4096&"
import script from "./ReleasesTable.vue?vue&type=script&lang=js&"
export * from "./ReleasesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports